import React, { useState, useRef, useEffect, useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import JsBarcode from 'jsbarcode';
import QRCode from "qrcode";
import './HYBRID_Token_Class.css';

const HYBRID_Token_Class = (props) => {
  const didFetchRef = useRef(false);
  const initRef = useRef({ headerHandled: false, dataTableHandled: false });

  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();

  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };


  const [newData, setNewData] = useState({
 	Source_Path:"HYBRID_TOKEN_CLASS",
    Status: App_Data.Status,
    Parameter: App_Data.Parameter,
    Search: App_Data.Search,
    Return_Path: App_Data.Return_Path,
    Return_ID: App_Data.ID,
    Return_Status: App_Data.Return_Status,
	Object_Text:";",
	HYBRID_TOKEN_CLASS:-1
  });


  const [HYBRID_TOKEN_CLASS, setHYBRID_TOKEN_CLASS] = React.useState(null);
  const [HYBRID_TOKEN_CLASS_D, setHYBRID_TOKEN_CLASS_D] = React.useState(null);



 
  useEffect(() => {
    document.title = "SRWAE | "+t('Hybrid Token Token Class');  
	  
 
	if(location.hash=="#Return"){
		setNewData({ ...newData});
		setApp_Data({ ...newData})
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#New"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};

		const clientInfo = collectClientInfo();
		handleLoadNewHYBRID_TOKEN_CLASS(clientInfo,"OpenNew");

		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Search"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class_S',{replace:true});
	}
	if(location.hash=="#Update"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
		if(Temp_Data2.status!="New"){
			Temp_Data2.status = "UpToDate";
			handlePutHYBRID_TOKEN_CLASS(Temp_Data2);
		}else{
			Temp_Data2.status = "UpToDate";
			handlePostHYBRID_TOKEN_CLASS(Temp_Data2);
			const collectClientInfo = () => {
			  return {
				userAgent: navigator.userAgent,
				language: navigator.language,
				platform: navigator.platform,
				screenResolution: `${screen.width}x${screen.height}`,
				colorDepth: screen.colorDepth,
				timezoneOffset: new Date().getTimezoneOffset(),
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				cookieEnabled: navigator.cookieEnabled,
				javaEnabled: navigator.javaEnabled(),
				online: navigator.onLine,
				referrer: document.referrer,
				locationHref: window.location.href,
				screenOrientation: screen.orientation?.type || 'unknown'
			  };
			};

			const clientInfo = collectClientInfo();
			handleLoadNewHYBRID_TOKEN_CLASS(clientInfo,"OpenNew");
		}
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		var Temp_Data2 =  JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
		if(Temp_Data2.status!="New"){
			handleDeleteHYBRID_TOKEN_CLASS(Temp_Data2);
			navigate('/HYBRID_Token_Class#New',{replace:true});
		} 
		else 
			navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Export"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Import"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#Help"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setNewData({ ...newData});
		setApp_Data({ ...newData});
		navigate('/HYBRID_Token_Class',{replace:true});
	}


  }, [location.hash]);   // Use cleanup for location.hash such as }, [location.hash]);



  useEffect(() => {
	  
	    if (!HYBRID_TOKEN_CLASS) return;

    if (!initRef.current.headerHandled) {
	  for (let i = 1; i <= 10; i++) {
	  const sectionId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_${i}_SECTION`;
	  const headerId = `#HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [0];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
      initRef.current.headerHandled = true;
  }


  if (!initRef.current.dataTableHandled) {

    initRef.current.dataTableHandled = true;
  }  

  }, [HYBRID_TOKEN_CLASS]) ;


  
  
  var Ids = [];
  for(var Ele in HYBRID_TOKEN_CLASS){
	  for(var Sec in HYBRID_TOKEN_CLASS[Ele]){
		if(Sec == "id")
			Ids.push(HYBRID_TOKEN_CLASS[Ele]["id"]);
		else if(Sec == "status")
			Ids.push(HYBRID_TOKEN_CLASS[Ele]["status"]);
		else if(Array.isArray(HYBRID_TOKEN_CLASS[Ele][Sec]))
			  for(var Row in HYBRID_TOKEN_CLASS[Ele][Sec])  // Convert to HYBRID_TOKEN_CLASS[Ele][Sec].forEach((row) => { ... })
				for (var Id in Row) 
					Ids.push(Id);
		else
			for (var Id in HYBRID_TOKEN_CLASS[Ele][Sec]) 
				Ids.push(Id);
	  }
  }
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
	if (didFetchRef.current) return;
    didFetchRef.current = true;

	var Temp_Data= JSON.parse(JSON.stringify(App_Data));
	Temp_Data["HYBRID_TOKEN_CLASS"] = 0;
	setApp_Data({...Temp_Data})

	const collectClientInfo = () => {
	  return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown',
	  };
	};
	const baseClientInfo = collectClientInfo();
	handleLoadNewHYBRID_TOKEN_CLASS(baseClientInfo,"FirstLoad");
 
/*	axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS`).then((response1) => {
		if(!HYBRID_TOKEN_CLASS) 
			setHYBRID_TOKEN_CLASS(JSON.parse(JSON.stringify(response1.data)));
		axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS_D`).then((response2) => {
			setHYBRID_TOKEN_CLASS_D( JSON.parse(JSON.stringify(response2.data)));
			handleAddHYBRID_TOKEN_CLASS_Load_Add_New(response1.data,response2.data);
		});
    });
*/

	//$('#navbarNav1').hide();
//$('#navbarNav6').hide();

  }, []);


 const handleLoadNewHYBRID_TOKEN_CLASS = async (clientInfo, status) => {
	axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS/New', {clientInfo, clientStamp: Date.now(), status:status})
	  .then(response => {
		setHYBRID_TOKEN_CLASS(response.data);
	  })
	  .catch(error => {
		console.error('Error sending client info:', error);
	  });
  };



   

 const handleLastDataHYBRID_TOKEN_CLASS = async (data) => {
	const collectClientInfo = () => {
	return {
		userAgent: navigator.userAgent,
		language: navigator.language,
		platform: navigator.platform,
		screenResolution: `${screen.width}x${screen.height}`,
		colorDepth: screen.colorDepth,
		timezoneOffset: new Date().getTimezoneOffset(),
		timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
		cookieEnabled: navigator.cookieEnabled,
		javaEnabled: navigator.javaEnabled(),
		online: navigator.onLine,
		referrer: document.referrer,
		locationHref: window.location.href,
		screenOrientation: screen.orientation?.type || 'unknown'
	  };
	};
	
	const clientInfo = collectClientInfo();

    fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS/Status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ data: data, clientInfo:clientInfo , stamp: Date.now() })
    }).catch(err => {
      console.error("Error", err);
    });
  };


  const handlePutHYBRID_TOKEN_CLASS = async (Updated) => {
    try {
		axios.put('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS/', Updated);
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
  
  const handlePostHYBRID_TOKEN_CLASS = async (Updated) => {
    try {
		axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS', Updated);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
 
   
 

  const handleDeleteHYBRID_TOKEN_CLASS = async (Updated) => {
    try {
		console.log(JSON.stringify(Updated));
		axios.delete('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/HYBRID_TOKEN_CLASS', {
            data: Updated,
            headers: {
                'Content-Type': 'application/json' 
			    }
            });
    } catch (error) {
      console.error('Error updating put:', error);
    }
  };
  
  
  
     
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["1"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("1","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  


const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["2"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"]=value;
	Form_Data_onChange("2","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["3"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("3","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
  
      
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["4"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("4","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  


    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["5"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("5","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  

const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"]=value;
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
  }; 
  

    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  
    
const HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
	Temp_Data["9"]["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"]=value;
	//handleAddHYBRID_TOKEN_CLASS(Temp_Data,App_Data['HYBRID_TOKEN_CLASS']);
	Form_Data_onChange("9","HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4",value,Temp_Data);
 	//handleLastDataHYBRID_TOKEN_CLASS(Temp_Data);
    setHYBRID_TOKEN_CLASS(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID,Value,Temp_Data) => {

};

  if (!HYBRID_TOKEN_CLASS) return <div>Loading...</div>;;

   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
    //newData.Return_Data=selectedRowId;
	setNewData({ ...newData});
	setApp_Data(newData)
    window.location.hash = 'Return';
   };

const handleAddRow = (Sec) => {
  const newRow = {};
  switch(Sec) {

  }


  const updatedHYBRID_TOKEN_CLASS =JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
  updatedHYBRID_TOKEN_CLASS[Sec] = [...updatedHYBRID_TOKEN_CLASS[Sec], newRow];
  setHYBRID_TOKEN_CLASS(updatedHYBRID_TOKEN_CLASS);
};

const handleDeleteRow = (sec,index) => {
  const updatedHYBRID_TOKEN_CLASS = JSON.parse(JSON.stringify(HYBRID_TOKEN_CLASS));
  updatedHYBRID_TOKEN_CLASS[sec].splice(index, 1);
  setHYBRID_TOKEN_CLASS(updatedHYBRID_TOKEN_CLASS);
}; 

 const print_Canvas = async (ID) => {
const canvas = document.getElementById(ID);
const imgData = canvas.toDataURL("image/png");

const printWindow = window.open('', '_blank');
printWindow.document.write(`
  <html>
    <head><title>Print</title></head>
    <body style="margin:0">
      <img src="${imgData}" style="width:100%;"/>
      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() {
            window.close();
          };
        };
      </script>
    </body>
  </html>
`);
printWindow.document.close();
}
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
  {t(`Hybrid Token Token Class`)}
  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item active">
					  <a  id="navbarNav2" className="nav-link" href="#New">{t(`New`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav3" className="nav-link" href="#Search">{t(`Search`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav4" className="nav-link" href="#Update">{t(`Update`)}</a>
				   </li>
				   <li className="nav-item">
					  <a  id="navbarNav8" className="nav-link" href="#Delete">{t(`Delete`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>	
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Hybrid Token Token Class ID`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`HYBRID Token Class ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0" type="text" className="form-control" placeholder="HYBRID Token Class ID" value={HYBRID_TOKEN_CLASS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter HYBRID Token Class ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Offering ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1" type="text" className="form-control" placeholder="Offering ID" value={HYBRID_TOKEN_CLASS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Offering ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '80ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Class Name`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2" type="text" className="form-control" placeholder="Token Class Name" value={HYBRID_TOKEN_CLASS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '80ch' }}>
						 {t(`Enter Token Class Name`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Token Symbol`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3" type="text" className="form-control" placeholder="Token Symbol" value={HYBRID_TOKEN_CLASS["1"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Token Symbol`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Seniority Level`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Seniority Level`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0"  value={HYBRID_TOKEN_CLASS["2"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_0_Change} className="form-control" name="Seniority Level"  >
						  <option value="Senior">Senior</option>
						  <option value="Preferred">Preferred</option>
						  <option value="Common">Common</option>
						  <option value="Subordinated">Subordinated</option>
						  <option value="Mezzanine">Mezzanine</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Seniority Level
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Economic Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1"  value={HYBRID_TOKEN_CLASS["2"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_1_Change} className="form-control" name="Token Economic Model"  >
						  <option value="Rental Income">Rental Income</option>
						  <option value="Revenue Share">Revenue Share</option>
						  <option value="Sale Profit">Sale Profit</option>
						  <option value="Equity Appreciation">Equity Appreciation</option>
						  <option value="Preferred Return">Preferred Return</option>
						  <option value="Common Equity">Common Equity</option>
						  <option value="Debt Interest">Debt Interest</option>
						  <option value="Hybrid">Hybrid</option>
						  <option value="Pre-Auction Conditional Pool">Pre-Auction Conditional Pool</option>
						  <option value="Post-Auction Tokenization">Post-Auction Tokenization</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Economic Model
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Token Ownership Model`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2"  value={HYBRID_TOKEN_CLASS["2"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_2_2_Change} className="form-control" name="Token Ownership Model"  >
						  <option value="No Direct Ownership / Economic Right Only">No Direct Ownership / Economic Right Only</option>
						  <option value="Revenue Participation Right">Revenue Participation Right</option>
						  <option value="Sale Proceeds Participation">Sale Proceeds Participation</option>
						  <option value="Equity Appreciation Participation">Equity Appreciation Participation</option>
						  <option value="Preferred Equity Interest">Preferred Equity Interest</option>
						  <option value="Common Equity Ownership Percentage">Common Equity Ownership Percentage</option>
						  <option value="Debt / Note Holder Claim">Debt / Note Holder Claim</option>
						  <option value="Hybrid Economic Rights">Hybrid Economic Rights</option>
						  <option value="Conditional Auction Pool Right">Conditional Auction Pool Right</option>
						  <option value="Post-Auction Asset Economic Right">Post-Auction Asset Economic Right</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Token Ownership Model
				     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Preferred Return Percentage`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Preferred Return Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0" type="text" className="form-control" placeholder="Preferred Return Percentage" value={HYBRID_TOKEN_CLASS["3"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Preferred Return Percentage`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Debt Interest Rate`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1" type="text" className="form-control" placeholder="Debt Interest Rate" value={HYBRID_TOKEN_CLASS["3"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Debt Interest Rate`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Profit Split Percentage`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2" type="text" className="form-control" placeholder="Profit Split Percentage" value={HYBRID_TOKEN_CLASS["3"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Profit Split Percentage`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Voting Weight`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Voting Weight`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0" type="text" className="form-control" placeholder="Voting Weight" value={HYBRID_TOKEN_CLASS["4"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Voting Weight`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Transfer Restricted`)} <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1_Change} 
					  checked={HYBRID_TOKEN_CLASS?.["4"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"] === "true" || HYBRID_TOKEN_CLASS?.["4"]?.["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_4_1"] === true} />
					</label>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Class Description`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Class Description`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0" type="text" className="form-control" placeholder="Class Description" value={HYBRID_TOKEN_CLASS["5"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_5_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Class Description`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
         {/* Section Section.Number Section.Title Section.Detail*/}
         <div className="container-fluid mt-5">
            <h2 id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Record Status`)} <span className="toggle-icon">^</span></h2>
            <div id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_SECTION" className="row">
			                {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0"  value={HYBRID_TOKEN_CLASS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0`]} onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1" type="text" className="form-control" placeholder="Created By" value={HYBRID_TOKEN_CLASS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2" type="text" className="form-control" placeholder="Created At" value={HYBRID_TOKEN_CLASS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3" type="text" className="form-control" placeholder="Updated By" value={HYBRID_TOKEN_CLASS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4" type="text" className="form-control" placeholder="Updated At" value={HYBRID_TOKEN_CLASS["9"][`HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4`]} 
						onChange={HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["HYBRID_02_OFFERING_STRUCTURING_HYBRID_MODEL_SETUP_HYBRID_TOKEN_CLASS_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>

  </>;
};

export default HYBRID_Token_Class;  